/**
 * Http client for APICloud
 * various data models
 * @author Creaman Xu
 * @copyright Copyright (c) 2018 apicloud.com
 */

(function (window, factory) {
  window.ListModel || (window.ListModel = factory());
}(window, function () {
  "use strict";

  function ListModel(nop) {
    this.numberOfItemsInPage = parseInt(nop) || 10;
    this.items = [];
  }

  ClientUtils.assign(ListModel.prototype, {
    nextPageIndex: function () {
      return this.numberOfItemsInPage <= 0 ? 0 :
        Math.ceil(this.items.length / this.numberOfItemsInPage) + 1;
    },
    append: function (data, refresh) {
      this.items = (refresh ? [] : this.items).concat(data);
      return data.length !== 0 && (data.length % this.numberOfItemsInPage) === 0;
    }
  });

  return ListModel;
}));


// WEBPACK FOOTER //
// ./src/utils/model.js